import { Typography } from "@mui/material";
import styled, { keyframes } from "styled-components";
import { defaultTextColor } from "styles/general_styles";

interface ICardContainer {
	isHighlighted?: boolean;
	eventIsCompleted: boolean;
	isUserQualifiedToContribute?: boolean;
	image?: string;
}

export const CardContainer = styled.div<ICardContainer>`
	background: ${(props) => props.color};
	box-shadow: ${(props) =>
		props?.isHighlighted &&
		!props?.eventIsCompleted &&
		props?.isUserQualifiedToContribute
			? "0px 4px 16px 5px #FFDA58"
			: "0px 6px 15px 0px rgba(0, 0, 0, 0.15)"};
	border-radius: 26px;
	margin: 10px 0px 10px 0px;
	animation: fadeIn 1s;
	position: relative;
	max-width: 400px;
	height: auto;
	width: 100%;
	min-height: 325px;
	font-size: 12px;
	overflow: hidden;

	&.several-items {
		min-height: 370px;
	}
`;

export const ImageContainer = styled.div<{ image: string }>`
	position: relative;
	background-image: url(${(props) => props.image});
	background-repeat: no-repeat;
	background-size: 100% auto;
	width: 100%;
	height: 107.25px /*33%*/;
	display: flex;
	align-items: center;
`;

export const DataContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 3px;
	padding: 8px;
`;

export const Title = styled.div`
	width: 60%;
	color: #fff;
	text-shadow: 0 0 5px #113b62, 0 0 5px #113b62, 0 0 5px #113b62,
		0 0 5px #113b62, -1px -1px 0 #113b62, 1px -1px 0 #113b62, -1px 1px 0 #113b62,
		1px 1px 0 #113b62, -2px -2px 0 #113b62, 2px -2px 0 #113b62,
		-2px 2px 0 #113b62, 2px 2px 0 #113b62;

	font-family: Baloo;
	font-size: clamp(2em, 2.2dvw, 2.4em);

	font-style: normal;
	font-weight: 400;
	line-height: 30px;
	margin-left: 10px;
`;

export const SubTitle = styled.div`
	text-align: left;
	color: ${(props) => props.color || defaultTextColor};
	font-weight: 700;
	font-size: 1em;
	line-height: 15px;
	position: relative;
`;

export const RewardsContainer = styled.div<{ borders: string }>`
	flex-basis: 50%;
	background: #ebebeb;
	border-radius: ${(props) => props.borders};
	display: flex;
	align-items: center;
	justify-content: space-around;
	height: 100px;
	padding-top: 5px;

	&.several-items {
		flex-wrap: wrap;
		height: 139px;
	}

	&.timed-rewards {
		flex-wrap: wrap;
		height: 139px;
	}
`;

export const Reward = styled.div`
	position: relative;
	font-size: 1em;
	flex-basis: 33%;
	text-align: center;

	> div {
		position: relative;
	}
`;

export const RewardIcon = styled.img`
	max-height: 4.667em;
	position: relative;
	z-index: 1;

	&.small-items {
		max-height: 4.165em;
	}
`;

export const NumberValue = styled.span`
	position: absolute;
	bottom: -14%;
	right: 18%;
	font-family: "Baloo";
	color: #fff;
	z-index: 1;
	color: white;
	text-shadow: 2px 1px 0px #000;
	-webkit-text-stroke-width: 4px;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	display: flex;
	font-size: 1.6em;
	align-items: center;
`;

export const StarBurstFrames = keyframes`
  0%, 100% {
		transform: translate(-50%, -50%) rotateZ(0deg);
	}
	50% {
		transform: translate(-50%, -50%) rotateZ(180deg);
	}
`;

export const StarBurst = styled.img`
	animation: ${StarBurstFrames} 15s ease infinite;
	position: absolute;
	top: 50%;
	left: 50%;
	opacity: 0.8;
	width: 101px;
	height: 101px;
`;

export const Value = styled(Typography)`
	font-weight: 500;
	font-family: "Baloo";
	color: white;
	display: flex;
	align-items: center;
	justify-content: center;
	width: max-content;
	font-size: 1.3em;
	position: relative;
	z-index: 1;
	text-shadow: 2px 1px 0px #000;
	-webkit-text-stroke-width: 4px;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	line-height: 1em;

	&.anchor {
		position: absolute;
		bottom: 10%;
		left: 45%;
	}
`;

export const CrossOutValue2 = styled(Value)<{ display?: "block" | "none" }>`
	color: #eb5757;
	font-family: "Inter";
	text-shadow: none;
	-webkit-text-stroke-width: 0;
	font-size: 1.2em;

	&.thankyoucoins {
		font-family: "Baloo";
		-webkit-text-stroke-width: 4px;
		position: absolute;
		bottom: 31%;
		left: 50%;
	}

	&:after {
		content: "";
		position: absolute;
		width: 105%;
		height: 1px;
		background-color: #eb5757;
		border-radius: 8px;
		border: 1px solid black;
		display: ${(props) => props.display};
	}
`;

export const CrossOutValue = styled(Typography)`
	color: #eb5757;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
	width: max-content;
	font-size: 1em;
	position: relative;
	z-index: 2;

	&.thankyoucoins {
		position: absolute;
		top: -45%;
		text-decoration: line-through;
		text-decoration-thickness: 1.5px;

		@media (min-width: 733px) {
			text-decoration-thickness: 1.4px;
		}
		@media (min-width: 1150px) {
			text-decoration-thickness: 1.5px;
		}
	}

	&.reward {
		position: absolute;
		top: unset;
		bottom: 12px;
		right: 5%;
		font-size: 1.33em;
		text-shadow: 0 0 3px #000, 0 0 3px #000, 0 0 3px #000, 0 0 3px #000,
			0 0 3px #000, 0 0 3px #000, 0 0 3px #000, 0 0 3px #000, 0 0 3px #000,
			0 0 3px #000;
		font-weight: 800;
		//text-decoration: line-through;
		//text-decoration-thickness: 1.2px;
	}
`;

export const CrossOutLine = styled("span")`
	border-bottom: 2px solid #eb5757;
	width: 100%;
	height: 1px;
	display: block;
	position: absolute;
	top: 40%;

	&.reward {
		top: 42%;
		border-radius: 2px;
		height: 2px;
		border: 1px solid #000;
		background: #eb5757;
	}
`;

export const ThanksMessage = styled.div<{ isFirstContribution: boolean }>`
	position: relative;
	text-align: center;
	color: ${(props) => props.color || defaultTextColor};
	font-weight: 700;
	font-size: ${(porps) => (porps.isFirstContribution ? "9px" : "12px")};
	padding: 0 2% 4% 2%;
	line-height: ${(porps) => (porps.isFirstContribution ? "9px" : "12px")};
`;

export const Footer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	justify-content: center;
`;

export const LoyaltyPoints = styled.div`
	background-color: #ebebeb;
	color: #333;
	font-size: 1.2em;
	font-weight: 700;
	padding: 0.5em 0.9em;
	border-radius: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2px;

	&.crossout {
		padding: 0.2em 0.8em;
	}
`;

export const FinalMessage = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-weight: 700;
	font-size: 1.2em;
	height: 38px;
	text-align: center;
`;

export const TimedRewardDescription = styled.div`
	//flex-wrap: wrap;
	width: 60%;
	white-space: wrap;
	color: #113b62;
	font-family: Inter;
	font-size: 1.3em;
	//padding: 2px;
	font-style: normal;
	font-weight: 700;
	line-height: 1em;
`;
